import http from '../lib/http';

// Get user profile
export const getProfile = async () => {
  try {
    const response = await http.get('/api/customer/profile');
    return response.data;
  } catch (error) {
    console.error('Error fetching profile:', error);
    throw error;
  }
};

// Update user profile
export const updateProfile = async (profileData) => {
  try {
    console.log('=== PROFILE SERVICE - UPDATE PROFILE ===');
    console.log('Received profile data:', profileData);
    
    const formData = new FormData();
    
    console.log('Creating FormData with profile data:', profileData);
    
    // Add profile image if provided (must be a File object)
    if (profileData.profile_image && profileData.profile_image instanceof File) {
      console.log('✅ Adding profile image to FormData:', profileData.profile_image);
      formData.append('profile_image', profileData.profile_image);
    } else {
      console.log('❌ No profile image or not a File object:', profileData.profile_image);
    }
    
    // Add other profile fields
    if (profileData.full_name) {
      formData.append('full_name', profileData.full_name);
      console.log('Added full_name:', profileData.full_name);
    }
    if (profileData.gender) {
      formData.append('gender', profileData.gender);
      console.log('Added gender:', profileData.gender);
    }
    if (profileData.email) {
      formData.append('email', profileData.email);
      console.log('Added email:', profileData.email);
    }
    if (profileData.birthdate) {
      formData.append('birthdate', profileData.birthdate);
      console.log('Added birthdate:', profileData.birthdate);
    }
    if (profileData.phone) {
      formData.append('phone', profileData.phone);
      console.log('Added phone:', profileData.phone);
    }
    if (profileData.country_code) {
      formData.append('country_code', profileData.country_code);
      console.log('Added country_code:', profileData.country_code);
    }

    // Log FormData contents for debugging
    console.log('=== FormData contents ===');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    console.log('Making API call to /api/customer/profile...');
    console.log('FormData entries:');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }
    
    const response = await http.post('/api/customer/profile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    console.log('✅ API call successful:', response.data);
    console.log('Response status:', response.status);
    console.log('Response headers:', response.headers);
    return response.data;
  } catch (error) {
    console.error('❌ Error updating profile:', error);
    console.error('Error details:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    throw error;
  }
};
